import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.css']
})
export class ConfirmationComponent implements OnInit {

  public quoteNumber: string;
  public applicationId: number;

  constructor(private router: Router) {
  }

  ngOnInit(): void {
    // Try to get state from history (works for direct navigation)
    const state = history.state;
    
    if (state && state.referenceNumber) {
      this.quoteNumber = state.referenceNumber;
      this.applicationId = state.applicationId;
    } else {
      // If no state found, redirect to quotes page for security
      this.router.navigate(['/quotes']);
    }
  }

}
